/**
 * FirmwarePayloadComponent created by karora on 02/01/18.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from "../app.component";
import {Router} from "@angular/router";

/*
{
  "fwsetid":1,
  "hash":"d78fde4c291d5041bb358974babb29d135fe4e93",
  "hashtype":"sha-1",
  "size":670704,
  "stable":false,
  "uri":"http://cdn.hubcontrols.com/hub/firmware/firmware-0.6.44-release.bin",
  "version":"0.6.44"
}
 */

class versionInfo {
  fwsetid: number;
  hash: string;
  hashtype: string;
  size: number;
  stable: boolean;
  uri: string;
  version: string;
}

@Component({
  selector: 'checkfirmwareversion-payload',
  template: `
    <div id="firmware_version" *ngIf="payload && payload != '{}' && !!payload.hash">
        <span class="prompt">Version:</span><span class="version">{{gotVersion.version}}</span>
        <span class="prompt">Size:</span><span class="size">{{gotVersion.size}}</span><br/>
        <span class="prompt">{{gotVersion.hashtype}}:</span><span class="hash">{{gotVersion.hash}}</span><br/>
        <span class="prompt">URI:</span><span class="uri">{{gotVersion.uri}}</span>
    </div>`,
  styles: [
    '#firmware_version { display: inline;}',
    'span { color: black; display: inline-block}',
    '.hubrow {width: 100%; display: block}',
    '.hubrow:hover { background-color: bisque}',
    '.prompt { font-weight: lighter; width: 4em; color: #444444;}',
    '.version { font-weight: bold; width: 5em; text-align: left;}',
    '.size { width: 4em; text-align: right}',
    '.hash { display: inline-block; white-space: nowrap}',
    '.uri { display: inline-block; white-space: nowrap}'
  ]
})

export class FirmwarePayloadComponent implements OnInit {
  @Input() payload: any;
  gotVersion: versionInfo;
  errorMessage: string;

  constructor(
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) return;
    this.gotVersion = <versionInfo>this.payload;
  }

}
